/**
 * The review page scrolls around each wide, independently scrollable table.
 * Keep several readable rows in short windows instead of subtracting estimated
 * toolbars from the viewport, which could leave only the sticky table header.
 */
export const reviewTableSx = {
  maxHeight: 'clamp(240px, calc(var(--app-content-height, 100dvh) * 0.55), 640px)',
  overflow: 'auto',
} as const;
